import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowUpRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M18.25 15.5C18.6642 15.5 19 15.1642 19 14.75L19 5.75C19 5.33579 18.6642 5 18.25 5L9.25 5C8.83579 5 8.5 5.33579 8.5 5.75C8.5 6.16421 8.83579 6.5 9.25 6.5L16.4393 6.5L6.21967 16.7197C5.92678 17.0125 5.92678 17.4874 6.21967 17.7803C6.51256 18.0732 6.98744 18.0732 7.28033 17.7803L17.5 7.56066L17.5 14.75C17.5 15.1642 17.8358 15.5 18.25 15.5Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgArrowUpRight;
